import { render, staticRenderFns } from "./courseForm.vue?vue&type=template&id=00566b14&scoped=true&"
import script from "./courseForm.vue?vue&type=script&lang=js&"
export * from "./courseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00566b14",
  null
  
)

export default component.exports